"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ContentRegistry = _interopRequireDefault(require("./ContentRegistry"));
var _jsxRuntime = require("react/jsx-runtime");
const Columns = ({
  content
}) => {
  if (!content) {
    return null;
  }
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: Object.values(content).map(column => column.map(contentElement => (0, _jsxRuntime.jsx)(_ContentRegistry.default, {
      contentElement: contentElement
    }, contentElement.id)))
  });
};
var _default = Columns;
exports.default = _default;